import { render, staticRenderFns } from "./BuildingEditSurveysTab.vue?vue&type=template&id=92d09b32"
import script from "./BuildingEditSurveysTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditSurveysTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports